import { gql } from "@apollo/client";

const LOGIN_MUTATION = gql`
  mutation signIn($email: String!, $password: String!) {
    signIn(email: $email, password: $password) {
      token
      user {
        id
        name
        firstName
        lastName
        name
        displayName
        profile_pic
        phoneno
        dob
        isActive
        isEmailVarified
        isUserVerified
        isVerified
        isDeleted
        isForceResetPassword
        email
        roles {
          id
          key
        }
        userOrg {
          id
          isDeleted
          isIndividual
          organization {
            id
            name
            leagalName
            phoneNo
            pin
            email
            isSeller
          }
          isVerified
          roles {
            id
            key
          }
        }
        currentOrganization {
          id
          name
          email
          leagalName
          phoneNo
          website
          sellerFee
          offerThreshold
        }
      }
    }
  }
`;

const SIGNUP_MUTATION = gql`
  mutation signUp(
    $firstName: String
    $lastName: String
    $email: String!
    $password: String!
    $phoneNo: String
    $roleKey: String!
    $organizationName: String
    $customerType: String
    $name: String!
    $organizationId: String
  ) {
    signUp(
      organizationId: $organizationId
      firstName: $firstName
      lastName: $lastName
      email: $email
      phoneNo: $phoneNo
      password: $password
      roleKey: $roleKey
      organizationName: $organizationName
      customerType: $customerType
      name: $name
    ) {
      token
      user {
        id
        name
        firstName
        lastName
        name
        displayName
        profile_pic
        phoneno
        dob
        isActive
        isEmailVarified
        isUserVerified
        isVerified
        isDeleted
        isForceResetPassword
        email
        roles {
          id
          key
        }
        userOrg {
          id
          isDeleted
          isIndividual
          organization {
            id
            name
            leagalName
            phoneNo
            pin
            email
            isSeller
          }
          isVerified
          roles {
            id
            key
          }
        }
        currentOrganization {
          id
          name
          email
          leagalName
          phoneNo
          website
          sellerFee
          offerThreshold
        }
      }
    }
  }
`;

const SOCIAL_SIGNIN = gql`
  mutation socialSignIn($email: String!) {
    socialSignIn(email: $email) {
      token
      user {
        id
        name
        firstName
        lastName
        name
        displayName
        profile_pic
        phoneno
        dob
        isActive
        isEmailVarified
        isUserVerified
        isVerified
        isDeleted
        isForceResetPassword
        email
        roles {
          id
          key
        }
        userOrg {
          id
          isDeleted
          isIndividual
          organization {
            id
            name
            leagalName
            phoneNo
            pin
            email
            isSeller
          }
          isVerified
          roles {
            id
            key
          }
        }
        currentOrganization {
          id
          name
          email
          leagalName
          phoneNo
          website
          sellerFee
          offerThreshold
        }
      }
    }
  }
`;

const WORKVU_MUTATION = gql`
  mutation companySignUp(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $roleKey: String!
  ) {
    companySignUp(
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      roleKey: $roleKey
    ) {
      token
      user {
        id
        firstName
        lastName
        email
      }
      organization {
        name
      }
    }
  }
`;

const JOIN_WORKVU_MUTATION = gql`
  mutation workerSignup(
    $email: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $companyName: String!
    $signUpType: String!
  ) {
    workerSignup(
      email: $email
      password: $password
      firstName: $firstName
      lastName: $lastName
      companyName: $companyName
      signUpType: $signUpType
    ) {
      token
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

const COMPANY_EDIT_MUTATION = gql`
  mutation saveCompanyDetail(
    $apt: String!
    $companyType: String!
    $street: String!
    $country: String!
    $state: String!
    $domain: String!
    $city: String!
    $name: String!
  ) {
    saveCompanyDetail(
      apt: $apt
      companyType: $companyType
      street: $street
      country: $country
      state: $state
      domain: $domain
      city: $city
      name: $name
    ) {
      id
    }
  }
`;

const SET_INVITED_USER_PASSWORD = gql`
  mutation setInvitedUserPassword(
    $phoneno: String!
    $idToken: String!
    $password: String!
  ) {
    setInvitedUserPassword(
      phoneno: $phoneno
      idToken: $idToken
      password: $password
    ) {
      id
    }
  }
`;

const SEND_FORGET_PASSWORD_LINK = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email) {
      id
    }
  }
`;

const SEND_COMPLETE_PROFILE_LINK = gql`
  mutation completeProfileMailUser($email: String!) {
    completeProfileMailUser(email: $email) {
      id
    }
  }
`;

const SOCIAL_SIGNUP = gql`
  mutation socialSignup(
    $roleKey: String!
    $signUpType: String!
    $email: String!
    $lastName: String!
    $firstName: String!
  ) {
    socialSignup(
      roleKey: $roleKey
      signUpType: $signUpType
      email: $email
      lastName: $lastName
      firstName: $firstName
    ) {
      token
      user {
        id
        firstName
        lastName
        email
        isUserVerified
        roles {
          id
          key
        }
      }
    }
  }
`;

const SET_PASSWORD = gql`
  mutation setPassword($emailToken: String!, $password: String!) {
    setPassword(emailToken: $emailToken, password: $password) {
      id
    }
  }
`;

const SET_WORKER_COMPANY = gql`
  mutation saveWorkerCompany($name: String!) {
    saveWorkerCompany(companyName: $name) {
      id
    }
  }
`;

const VERIFY_EMAIL = gql`
  mutation varifyEmail($emailToken: String!) {
    varifyEmail(emailToken: $emailToken) {
      id
      name
      firstName
      lastName
      name
      displayName
      profile_pic
      phoneno
      dob
      isActive
      isEmailVarified
      isUserVerified
      isVerified
      isDeleted
      isForceResetPassword
      email
      roles {
        id
        key
      }
      userOrg {
        id
        isDeleted
        isIndividual
        organization {
          id
          name
          leagalName
          phoneNo
          pin
          email
          isSeller
        }
        isVerified
        roles {
          id
          key
        }
      }
      currentOrganization {
        id
        name
        email
        leagalName
        phoneNo
        website
        sellerFee
        offerThreshold
      }
    }
  }
`;

const SIGNOUT = gql`
  mutation {
    signOut
  }
`;

export const SAVE_SELLER_INFO = gql`
  mutation(
    $orgId: String!
    $pin: String!
    $phoneNo: String!
    $email: String!
    $legalName: String!
    $name: String!
  ) {
    updateOrganization(
      orgId: $orgId
      pin: $pin
      phoneNo: $phoneNo
      email: $email
      leagalName: $legalName
      name: $name
    ) {
      id
      leagalName
      name
      pin
      phoneNo
      isSeller
      email
    }
  }
`;

export {
  LOGIN_MUTATION,
  SOCIAL_SIGNIN,
  WORKVU_MUTATION,
  JOIN_WORKVU_MUTATION,
  COMPANY_EDIT_MUTATION,
  SET_INVITED_USER_PASSWORD,
  SEND_FORGET_PASSWORD_LINK,
  SET_PASSWORD,
  SOCIAL_SIGNUP,
  SIGNUP_MUTATION,
  SET_WORKER_COMPANY,
  VERIFY_EMAIL,
  SIGNOUT,
  SEND_COMPLETE_PROFILE_LINK,
};
